import { Component, OnInit, ViewChild } from '@angular/core';
import { DAO } from '../../modal/DAO';
import { ServiceLayer } from '../../services/serviceLayer';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
import { User } from '../../modal/User';

declare var $: any;
@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.css']
})
export class PolicyComponent implements OnInit {

  public IsCancelOCP: boolean = false;
  public cancelPopupDetails: any = [];
  public cancelDetails: any = [];
  public IsCancelPopup: boolean = false;
  public IsCancel: boolean = false;
  public userDetailsFromAuth: Observable<User | null>;
  public ActiveTab : string = 'client-data';
  constructor(private serviceLayer: ServiceLayer, public dao: DAO, public authenticationService: AuthenticationService) {
  }
  ngOnInit(): void {
    this.checkLoginCredential();
    this.getPolicyDetails()
  }
  //===============check login credential============
  checkLoginCredential() {
    // this.jwt$ = this.authenticationService.jwt$;
    this.userDetailsFromAuth = this.authenticationService.user$;
    if ((location.href.split("#") && location.href.split("#").length > 1 && location.href.split("#")[1].split("&").some(data => data.startsWith('error_description')))) {
      // Commented out this condition for Ticket 349: removed metadata company check from login validation
      //(this.dao.loginUserDetail && this.dao.loginUserDetail.userCompanyGroup && this.dao.loginUserDetail.userCompanyGroup === 'Others')) 
      window.location.href = "/xps/unauthenticated";
    }
    //==============assigne login user details from Auth call==============
    if ((!this.dao.loginUserDetail || this.dao.loginUserDetail.isVerifiedSITAuth === undefined) && this.userDetailsFromAuth && this.userDetailsFromAuth.source) {
      this.saveUserDetails(this.userDetailsFromAuth.source['_value']);
    }

  }
  //=================get client data details==============
  async getPolicyDetails() {
    // return await this.serviceLayer.getPolicyDetail();
  }
  //===========show popup for cancel policy============
  async clickCancelPolicy() {
    this.IsCancelPopup = false;
    let response = await this.serviceLayer.getCancelReasonDetails();
    if (response) {
      this.cancelDetails = response['popupInputObj'];
      this.cancelPopupDetails = response['originalObj']
      this.IsCancelPopup = true;
      return response;
    }
  }
  //===========send the cancel policy detail to service============
  async pushCancelDetails() {
    // let response = await this.serviceLayer.cancelationDetail(this.cancelPopupDetails);
    // if (!response) {
    //   this.IsCancel = true;
    // }
    return null;
  }
  //===========save the login user details==================
  async saveUserDetails(userData) {
    if (userData && userData.email) {
      // await this.serviceLayer.sitUserAuthenticationCall('client', 'SITUserVerification', userData);
    }
  }

}
